"use client"

import React from "react"
import { TruckIcon } from "lucide-react"
import { Checkbox } from "@/components/ui/checkbox"; // <-- use your styled Checkbox
import { Label } from "@radix-ui/react-label";

export interface DropshipperFormData {
  isDropshipper: boolean
  name: string
  lastName: string
  phoneNumber: string
}

interface DropshipperFormProps {
  dataDropshipper: DropshipperFormData
  setDataDropshipper: React.Dispatch<React.SetStateAction<DropshipperFormData>>
  showPhoneNumber: boolean
}

export default function DropshipperForm({ dataDropshipper, setDataDropshipper, showPhoneNumber }: DropshipperFormProps) {
  // Helper to update dropshipper fields
  const handleInputChange = (field: keyof DropshipperFormData, value: string | boolean) => {
    setDataDropshipper(prev => ({
      ...prev,
      [field]: value,
    }))
  }

  return (
    <div className="w-full mx-auto">
      <form className="space-y-6">
        {/* Checkbox */}
        <div className="flex items-center gap-3">
          <Checkbox
            id="isDropshipper"
            checked={dataDropshipper.isDropshipper}
            onCheckedChange={(checked) => handleInputChange("isDropshipper", checked)}
            className="rounded transition-all duration-300 ease-in-out"
          />
          <Label htmlFor="isDropshipper" className="text-sm font-medium text-gray-900">
            Deliver as Dropshipper
          </Label>
        </div>

        {/* Conditional Form Fields */}
        {dataDropshipper.isDropshipper && (
          <>
            {/* Header */}
            <div className='flex items-center gap-x-2'>
              <TruckIcon className='mt-0.5 h-5 w-5' />
              <h2 className='text-lg md:text-xl'>Dropshipper</h2>
            </div>
          
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-900">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  value={dataDropshipper.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                  placeholder="Please fill your first name"
                  className="flex h-9 w-full rounded-sm border border-input bg-transparent px-3 py-5 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                />
              </div>

              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-900">
                  Last Name
                </label>
                <input
                  type="text"
                  value={dataDropshipper.lastName}
                  onChange={(e) => handleInputChange("lastName", e.target.value)}
                  placeholder="Please fill your last name"
                  className="flex h-9 w-full rounded-sm border border-input bg-transparent px-3 py-5 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                />
              </div>
            </div>
                      

            {/* Phone Number Field */}
            {showPhoneNumber && (
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-900">
                Phone Number <span className="text-red-500">*</span>
              </label>
              <input
                type="tel"
                required
                value={dataDropshipper.phoneNumber}
                onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
                placeholder="Enter your phone number"
                className="flex h-9 w-full rounded-sm border border-input bg-transparent px-3 py-5 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
              />
            </div>
            )}
          </>
        )}
      </form>
    </div>
  )
}